export default __webpack_public_path__ + "static/media/600.57331122.gif";